export default __webpack_public_path__ + "static/media/logosiemens.89b1182e.png";